module.exports = "<settings-list></settings-list> ";


//////////////////
// WEBPACK FOOTER
// ./app/settings/settings.html
// module id = 857
// module chunks = 0